<template>
  <CollectionCarouselHelper
    v-slot="{ products }"
    :collection-handle="collectionHandle"
  >
    <HomepageProductCarousel
      :title="title"
      :subtitle="subtitle"
      :link="link"
      :products="products"
      slide-width="310px"
      slide-width-tablet="310px"
      slide-width-desktop="300px"
    />
  </CollectionCarouselHelper>
</template>

<script>
import HomepageProductCarousel from "@/components/homepage/HomepageProductCarousel.vue";
import CollectionCarouselHelper from "@/components/CollectionCarouselHelper.vue";

export default {
  name: "HowToWearProductsCarousel",
  components: {
    HomepageProductCarousel,
    CollectionCarouselHelper,
  },
  props: {
    collectionHandle: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    subtitle: {
      type: String,
      required: true,
    },
    link: {
      type: String,
      required: true,
    },
  },
};
</script>
